// "/ids" (all transactions matching the applied filters): a 400 is a final
// answer (too many matches), and every "select all" counts again, since
// transactions can be added from anywhere (other users, scheduled payouts).
export const MATCHING_IDS_QUERY_OPTIONS = {
  retry: false,
  staleTime: 0,
}

// The backend answers "/ids" with a 400 above this many matches.
export const MATCHING_IDS_LIMIT = 10_000
